"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignatureVerifierFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        constant: true,
        inputs: [
            {
                internalType: "bytes32",
                name: "messageHash",
                type: "bytes32",
            },
        ],
        name: "getEthSpecificMessageHash",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "bytes32",
                name: "ethSpecificMessageHash",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "signature",
                type: "bytes",
            },
        ],
        name: "recoverSigner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "bytes",
                name: "signature",
                type: "bytes",
            },
        ],
        name: "splitSignature",
        outputs: [
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "signer",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "messageHash",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "signature",
                type: "bytes",
            },
        ],
        name: "verify",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "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";
class SignatureVerifierFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.SignatureVerifierFactory = SignatureVerifierFactory;
SignatureVerifierFactory.bytecode = _bytecode;
SignatureVerifierFactory.abi = _abi;
//# sourceMappingURL=SignatureVerifierFactory.js.map